var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 16.125C7.5 16.4702 7.77982 16.75 8.125 16.75L18.125 16.75C18.4702 16.75 18.75 16.4702 18.75 16.125L18.75 4.875C18.75 4.52982 18.4702 4.25 18.125 4.25L8.125 4.25C7.77982 4.25 7.5 4.52982 7.5 4.875L7.5 7.375C7.5 7.72018 7.22018 8 6.875 8C6.52982 8 6.25 7.72018 6.25 7.375L6.25 4.875C6.25 3.83946 7.08947 3 8.125 3L18.125 3C19.1605 3 20 3.83946 20 4.875L20 16.125C20 17.1605 19.1605 18 18.125 18L8.125 18C7.08947 18 6.25 17.1605 6.25 16.125L6.25 13.625C6.25 13.2798 6.52982 13 6.875 13C7.22018 13 7.5 13.2798 7.5 13.625L7.5 16.125Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.183058 10.9419C-0.0610196 10.6979 -0.0610196 10.3021 0.183058 10.0581L3.93306 6.30806C4.17714 6.06398 4.57286 6.06398 4.81694 6.30806C5.06102 6.55214 5.06102 6.94786 4.81694 7.19194L2.13388 9.875L13.125 9.875C13.4702 9.875 13.75 10.1548 13.75 10.5C13.75 10.8452 13.4702 11.125 13.125 11.125L2.13388 11.125L4.81694 13.8081C5.06102 14.0521 5.06102 14.4479 4.81694 14.6919C4.57286 14.936 4.17714 14.936 3.93306 14.6919L0.183058 10.9419Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.b4f54eb2dca9a8ad64499576da7ed160.svg";
export { ForwardRef as ReactComponent };